var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D3EAFF;}\r\n\t.st1{fill:#278DEC;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,23.7L12,23.7C5.5,23.7,0.3,18.5,0.3,12v0C0.3,5.5,5.5,0.3,12,0.3h0c6.5,0,11.7,5.2,11.7,11.7v0 C23.7,18.5,18.5,23.7,12,23.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.5,18.9h8.3c0.8,0,1.4-0.6,1.4-1.4V9.2c0-0.8-0.6-1.4-1.4-1.4H6.5c-0.8,0-1.4,0.6-1.4,1.4v8.3 C5.1,18.3,5.7,18.9,6.5,18.9z M7.9,12.7h2.1v-2.1h1.4v2.1h2.1v1.4h-2.1v2.1H9.9v-2.1H7.9V12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.5,5.1H9.2v1.4h8.3v8.3h1.4V6.5C18.9,5.7,18.3,5.1,17.5,5.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateIcon);
export default __webpack_public_path__ + "static/media/duplicateIcon.df3401d91d56524f776975de5e62c467.svg";
export { ForwardRef as ReactComponent };